<template>
  <v-card>
    <v-toolbar dark color="primary" tabs>
      <v-btn icon dark @click="closeForm()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>{{ $t('Crear solicitud') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn
          v-if="!disabled && adminView"
          :loading="savingData"
          :disabled="!enableMarkAsNotReaded"
          dark
          flat
          @click="markAsUnreaded()"
        >
          {{ $t('Marcar como no leída') }}
        </v-btn>
        <v-btn v-if="!disabled" :loading="savingData" dark flat @click="submit">
          {{ $t('Enviar') }}
        </v-btn>
        <v-btn v-if="disabled" :loading="savingData" dark flat @click="closeForm()">
          {{ $t('Cerrar') }}
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <div>
      <v-form ref="laboralRequestForm" v-model="valid">
        <v-card class="laboral-request-form">
          <div class="laboral-request-form__group">
            <v-card-text>
              <v-layout wrap>
                <v-flex xs4 pr-3>
                  <v-select
                    :disabled="disabled"
                    v-model="formData.type"
                    @input="$emit('input', formData)"
                    :label="$t('Tipo de solicitud')"
                    :items="typeOptions"
                    :rules="[rules.required]"
                    required
                    item-text="label"
                    item-value="value"
                    box
                    :menu-props="{
                      bottom: true,
                      'offset-y': true,
                    }"
                  ></v-select>
                </v-flex>
                <v-flex xs4 pr-3>
                  <v-menu
                    v-model="showRequestDatePicker"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                    :disabled="disabled"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        ref="date"
                        :rules="[rules.required, rules.minToday]"
                        v-model="formattedEffectDate"
                        class="pr-2"
                        :label="effectDateLabel"
                        readonly
                        mask="date"
                        v-on="on"
                        box
                        :disabled="disabled"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="formData.effect_date"
                      @input="showRequestDatePicker = false"
                      locale="es"
                      first-day-of-week="1"
                      :reactive="true"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex v-if="adminView" xs4 pr-3>
                  <!-- <v-text-field
                    v-model="formData.codempre"
                    :disabled="disabled"
                    :label="$t('Cod. Empresa')"
                    box
                    v-if="adminView"
                  ></v-text-field> -->
                  <clavedat-selector
                    v-model="formData.codempre"
                    :disabled="disabled"
                    required
                  ></clavedat-selector>
                </v-flex>
                <v-flex v-if="adminView && formData.id" xs4 pr-3>
                  <v-text-field
                    v-model="createdDate"
                    :label="$t('Fecha de creación de la solicitud')"
                    disabled
                    box
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout v-if="showEffectDateWarning" wrap>
                <v-flex xs12>
                  <v-alert class="mb-3" v-model="showEffectDateWarning" type="warning">
                    <b>AVISO IMPORTANTE</b>
                    <template v-if="formData.type === 'alta_trabajador'">
                      Tal y como se establece en las condiciones particulares de contratación, se
                      debe solicitar el alta de trabajadores con una antelación mínima de dos (2)
                      días hábiles. Por favor, contacte con el área laboral para confirmar que su
                      petición puede ser atendida y gestionada en plazo.
                    </template>
                    <template v-else-if="formData.type === 'baja_trabajador'">
                      Tal y como se establece en las condiciones particulares de contratación, se
                      debe solicitar la baja de trabajadores con una antelación mínima de dos (2)
                      días hábiles. Por favor, contacte con el área laboral para confirmar que su
                      petición puede ser atendida y gestionada en plazo.
                    </template>
                    <template v-else>
                      Tal y como se establece en las condiciones particulares de contratación, se
                      debe solicitar las modificaciones contractuales con una antelación mínima de
                      dos (2) días hábiles. Por favor, contacte con el área laboral para confirmar
                      que su petición puede ser atendida y gestionada en plazo.
                    </template>
                  </v-alert>
                </v-flex>
              </v-layout>

              <template v-if="formData.type === 'alta_trabajador'">
                <datos-trabajador
                  :disabled="disabled"
                  v-model="formData.worker_data"
                ></datos-trabajador>
                <alta-trabajador
                  :disabled="disabled"
                  v-model="formData.request_data"
                ></alta-trabajador>
              </template>

              <div v-if="formData.type === 'baja_trabajador'">
                <worker-selector
                  :codempre="selectedCodempre"
                  v-model="selectedWorker"
                ></worker-selector>
                <datos-trabajador
                  :disabled="disabled"
                  v-model="formData.worker_data"
                ></datos-trabajador>
                <baja-trabajador
                  :disabled="disabled"
                  v-model="formData.request_data"
                ></baja-trabajador>
              </div>
              <div v-if="formData.type === 'modificacion_contrato'">
                <worker-selector
                  :codempre="selectedCodempre"
                  v-model="selectedWorker"
                ></worker-selector>
                <datos-trabajador
                  :disabled="disabled"
                  v-model="formData.worker_data"
                ></datos-trabajador>
                <modificacion-contrato
                  :disabled="disabled"
                  v-model="formData.request_data"
                ></modificacion-contrato>
              </div>
              <div v-if="formData.type === 'otras'"></div>
              <v-alert type="warning" v-model="showCommentWarning" dismissible v-if="adminView">
                ¡Ojo! campo observaciones compartido con cliente... cualquier anotación será visible
                por el interesado.
              </v-alert>
              <v-btn
                dismissible
                v-if="adminView && !showCommentWarning"
                @click="toggleCommentWarning()"
                class="mt-0 pt-0"
                flat
                icon
                color="secondary"
              >
                <v-icon small>mdi-alert-octagon</v-icon>
              </v-btn>
              <v-textarea
                v-model="formData.comments"
                :disabled="disabled"
                @input="$emit('input', formData)"
                :label="$t('Observaciones')"
                :rules="
                  formData.request_data &&
                  formData.request_data.motivo_de_la_baja &&
                  formData.request_data.motivo_de_la_baja === 'otros'
                    ? [rules.required]
                    : []
                "
                :required="
                  formData.request_data &&
                    formData.request_data.motivo_de_la_baja &&
                    formData.request_data.motivo_de_la_baja === 'otros'
                "
                box
              ></v-textarea>
              <h3>{{ $t('Documentación aportada') }}</h3>
              <v-dialog max-width="500px" v-model="showUploadDocumentModal" v-if="!disabled">
                <v-hover :open-delay="0" slot="activator">
                  <v-btn
                    :disabled="disabled"
                    slot-scope="{ hover }"
                    :color="`${hover ? 'primary' : 'primary lighten-1'}`"
                  >
                    <v-icon>mdi-cloud-upload</v-icon>
                    <span class="ml-3">{{ $t('Subir') }}</span>
                  </v-btn>
                </v-hover>
                <og-message-file-upload
                  v-if="showUploadDocumentModal"
                  :userId="user.id"
                  @closeDialog="showUploadDocumentModal = false"
                  :category-id="3"
                  :month="documentMonth"
                  @postdocument="onDocumentUploaded"
                ></og-message-file-upload>
              </v-dialog>
              <template v-for="(document, index) in formData.documents">
                <v-card-text :key="`document-${document['id']}`">
                  <v-icon color="primary" @click="downloadEntity(document)">
                    mdi-download
                  </v-icon>
                  <span class="message-container ml-2 mr-2">{{ document['name'] }}</span>
                  <v-icon v-if="!disabled" color="primary" @click="removeDocument(index)">
                    mdi-trash-can-outline
                  </v-icon>
                </v-card-text>
              </template>
              <v-card-text v-if="!totalDocuments">
                <span class="message-container ml-2">
                  {{ $t('No se ha aportado ningún documento') }}
                </span>
              </v-card-text>
              <v-layout wrap>
                <v-flex xs12>
                  <v-alert
                    v-model="showErrorFormMessage"
                    border="left"
                    color="red"
                    dismissible
                    elevation="2"
                    prominent
                    outline
                    type="error"
                  >
                    {{ errorFormMessage }}
                  </v-alert>
                </v-flex>
              </v-layout>
            </v-card-text>
          </div>

          <v-card-actions class="mt-5">
            <v-btn @click="closeForm()">
              {{ $t('Cancelar') }}
            </v-btn>

            <v-spacer></v-spacer>
            <v-btn v-if="!disabled" :loading="savingData" @click="submit()">
              {{ $t('Enviar') }}
            </v-btn>
            <v-btn v-if="disabled" @click="closeForm()">
              {{ $t('Cerrar') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </div>
  </v-card>
</template>

<script>
import DatosTrabajador from './partials/DatosTrabajador.vue';
import AltaTrabajador from './partials/AltaTrabajador.vue';
import BajaTrabajador from './partials/BajaTrabajador.vue';
import ModificacionContrato from './partials/ModificacionContrato.vue';
import OgSimpleDateInput from '@/components/commons/form/inputs/OgSimpleDateInput.vue';
import WorkerSelector from '../../inputs/WorkerSelector.vue';
import ClavedatSelector from '@/components/commons/form/inputs/ClavedatSelector.vue';
import OgMessageFileUpload from '@/modules/myconsultant/components/threads/OgMessageFileUpload.vue';
import ThreadAPI from '@/modules/myconsultant/services/thread';
import apiCtrl from '@/services/api/abstract/abstract-api';
const moment = require('moment');

export default {
  components: {
    DatosTrabajador,
    AltaTrabajador,
    BajaTrabajador,
    ModificacionContrato,
    WorkerSelector,
    ClavedatSelector,
    OgMessageFileUpload,
  },
  props: {
    editForm: {
      type: Boolean,
      default: false,
    },
    codempre: {
      type: [String, Number],
      default: null,
    },
    adminView: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default() {
        return {
          comments: '',
          status: null,
          type: null,
          codempre: null,
          effect_date: null,
          date: null,
          worker_data: {},
          request_data: {},
          documents: [],
        };
      },
    },
    enableMarkAsNotReaded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showUploadDocumentModal: false,
      documentMonth: moment().format('YYYY-MM'),
      showRequestDatePicker: false,
      showCommentWarning: this.adminView,
      valid: true,
      savingData: false,
      workerDataReady: false,
      requestDataReady: false,
      showErrorFormMessage: false,
      errorFormMessage:
        'Hay errores en el formulario, comprueba que todos los campos estén correctamente rellenados',
      selectedWorker: null,
      rules: {
        required: value => !!value || 'Este campo es obligatorio.',
        counter: value => value.length <= 20 || 'Max 20 characters',
        minToday: value => {
          const requestDate = moment(this.formData.effect_date);
          const today = moment().startOf('day');

          if (!this.formData.id && this.formData.type === 'alta_trabajador') {
            const validDate = requestDate.isSameOrAfter(today);
            return (
              validDate ||
              'Seguridad Social no permite realizar altas con carácter retroactivo, sólo permite realizarlas previamente'
            );
          } else {
            return true;
          }
        },
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Email inválido';
        },
      },
      typeOptions: [
        { label: 'Alta trabajador', value: 'alta_trabajador' },
        { label: 'Baja trabajador', value: 'baja_trabajador' },
        { label: 'Modificación de contrato', value: 'modificacion_contrato' },
        { label: 'Otras', value: 'otras' },
      ],
    };
  },
  computed: {
    totalDocuments() {
      return this.formData.documents ? this.formData.documents.length : 0;
    },
    formattedEffectDate() {
      return this.formData.effect_date
        ? moment(this.formData.effect_date).format('DD/MM/YYYY')
        : '';
    },
    selectedCodempre() {
      return this.formData.codempre || this.codempre;
    },
    effectDateLabel() {
      if (this.formData.type === 'alta_trabajador') {
        return this.$t('Fecha de alta');
      }
      if (this.formData.type === 'baja_trabajador') {
        return this.$t('Fecha de baja');
      }

      return this.$t('Fecha de efecto');
    },
    requestType() {
      return this.formData.type;
    },
    showEffectDateWarning() {
      const effectDate = moment(this.formData.effect_date);
      const twoDaysFromToday = moment().add(2, 'days');
      const lessThan2Days = effectDate.isBefore(twoDaysFromToday);
      return this.formData.effect_date && lessThan2Days;
    },
    createdDate() {
      if (this.formData.created_at) {
        return moment(this.formData.created_at).format('DD/MM/YYYY HH:mm:ss');
      } else {
        return '';
      }
    },
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    user() {
      return this.$store.state.user;
    },
  },
  mounted() {
    this.$vuetify.goTo(0);
    // this.setMockData();
  },
  methods: {
    downloadEntity(document) {
      const mediaId = document['media'][0]['id'];
      apiCtrl
        .get('/document/download/' + mediaId)
        .then(res => {
          apiCtrl.downloadFile(res.data);
          if (!this.adminView && !document.pivot['downloaded']) {
            this.$emit('mark-document-as-downloaded', {
              id: this.formData.id,
              documentId: document.id,
            });
          }
          this.$root.$emit('getNewLaboralRequestDocuments');
        })
        .catch(error => {
          console.log(error);
        });
    },
    removeDocument(index) {
      this.formData.documents.splice(index, 1);
    },
    onDocumentUploaded: function(data) {
      if (this.formData.documents) {
        this.formData.documents.push(data.data);
      } else {
        this.formData.documents = [data.data];
      }
      this.showUploadDocumentModal = false;
    },
    setSelectedWorker(worker) {
      if (worker) {
        this.formData.worker_data = this.workerToWorkerData(worker);
      } else {
        this.formData.worker_data = {};
      }
    },
    workerToWorkerData(worker) {
      const workerData = {
        fullname: worker.fullname,
        nif: worker.NIF,
        num_ss: worker.NUM_AFILIACION,
        birthdate: worker.FEC_NACI,
        address: worker.address,
        city: worker.city,
        province: worker.province,
        cp: worker.CODPOS,
        nationality: worker.nationality,
        phone: worker.TELEF1 || worker.TELEF2,
        email: worker.EMAIL,
      };

      return workerData;
    },
    toggleCommentWarning() {
      this.showCommentWarning = true;
    },
    setMockData() {
      this.formData = {
        type: 'alta_trabajador',
        effect_date: moment().format('YYYY-MM-DD'),
        request_data: {
          tipo_de_contrato: 'sustitucion',
          obra_y_servicio: {},
          eventual: {},
          sustitucion: {
            nationality: 'Sofía Luque González',
            sustitucion_motivo: 'Baja Maternal',
            sustitucion_fecha_fin: '2021-09-30',
          },
          titulacion: 'Licenciado',
          categoria_profesional: 'Profesor',
          jornada_laboral: 'parcial',
          jornada_laboral_horas_semanales: '25',
          jornada_laboral_horario: '9:00 a 14:00 de Lunes a Viernes',
          remuneracion_bruta: 'pactada',
          remuneracion_bruta_cantidad: '30000',
          numero_de_pagas: '12',
        },
        worker_data: {
          fullname: 'Alberto Guerrero García de Arboleya',
          nif: '09189142K',
          num_ss: null,
          birthdate: '1984-02-27',
          address: 'Paseo de los rosales, 19',
          city: 'Merida',
          province: 'Badajoz',
          cp: '06800',
          nationality: 'España',
          phone: '669942874',
          email: 'albertoguerrerogarcia@gmail.com',
        },
        comments: 'Ninguna',
      };
    },
    markAsUnreaded() {
      this.$emit('mark-as-unreaded');
    },
    submit() {
      this.addExtraFields();
      const validate = this.validateForm();

      if (this.formData.documents) {
        this.formData.documentIds = this.formData.documents.map(item => item.id);
      } else {
        this.formData.documentIds = [];
      }

      if (validate) {
        this.$emit('submit', this.formData);
      }
    },
    addExtraFields() {
      if (!this.formData.date) {
        this.formData.date = moment().format('YYYY-MM-DD');
      }

      if (!this.formData.status) {
        this.formData.status = 'opened';
      }

      if (this.codempre) {
        this.formData.codempre = this.codempre;
      }
    },
    validateForm() {
      this.showErrorFormMessage = false;
      const res = this.$refs.laboralRequestForm.validate();

      if (!res) {
        this.showErrorFormMessage = true;
      }

      return res;
    },
    closeForm() {
      console.log('Close form');
      this.$emit('close-form');
    },
  },
  watch: {
    selectedWorker: {
      handler: function(val, oldVal) {
        this.setSelectedWorker(val);
      },
      deep: true,
    },
  },
};
</script>

<style lang="sass"></style>
